module.exports = __webpack_public_path__ + "static/media/collectionc-centre-2.1a07c9b5.jpg";